const SCAN_ACTION_RESOLUTION_ERROR_NAME = 'ScanActionResolutionError';
const SCAN_ACTION_EXECUTION_ERROR_NAME = 'ScanActionExecutionError';

/**
 * Creates the error raised when no scan action claims a scan event, or when a
 * predicate throws while resolving one.
 */
export const createScanActionResolutionError = (correlationId: string, cause?: unknown): Error => {
  const error = cause
    ? new Error(`A scan action predicate threw resolving the scan event ${correlationId}.`, {
        cause,
      })
    : new Error(`No scan action matched the scan event ${correlationId}.`);
  error.name = SCAN_ACTION_RESOLUTION_ERROR_NAME;
  return error;
};

/**
 * Creates the error raised when a scan action throws out of its `execute`.
 */
export const createScanActionExecutionError = (
  actionName: string,
  correlationId: string,
  cause: unknown,
): Error => {
  if (cause instanceof Error) {
    cause.name = SCAN_ACTION_EXECUTION_ERROR_NAME;
    return cause;
  }
  const error = new Error(
    `The ${actionName} scan action failed executing the scan event ${correlationId}.`,
    { cause },
  );
  error.name = SCAN_ACTION_EXECUTION_ERROR_NAME;
  return error;
};

/**
 * Type guard for {@link createScanActionResolutionError} results.
 */
export const isScanActionResolutionError = (error: unknown): error is Error =>
  error instanceof Error && error.name === SCAN_ACTION_RESOLUTION_ERROR_NAME;

/**
 * Type guard for {@link createScanActionExecutionError} results.
 */
export const isScanActionExecutionError = (error: unknown): error is Error =>
  error instanceof Error && error.name === SCAN_ACTION_EXECUTION_ERROR_NAME;
